/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取我的会员成长值明细
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GrowthScoresParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: GrowthScoresParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.MemberGrowthValueRecordDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/level/detail`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
